// extracted by mini-css-extract-plugin
export var container = "vk-venue-module--container--Jiv8W";
export var content = "vk-venue-module--content--iqDO-";